import { render, staticRenderFns } from "./deposits-block.vue?vue&type=template&id=be0260a8"
import script from "./deposits-block.vue?vue&type=script&lang=ts"
export * from "./deposits-block.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports